import type { ReactNode } from "react"
import { BugOutlined } from "@mimber/ui-web"
import { useReportIssueFeedback } from "../useReportIssueFeedback"
import type { PermissionedMenuItem } from "../usePermissionedMenuItems"

type MenuItemWithHandler = PermissionedMenuItem & {
  label: string
  icon: ReactNode
  onClick: () => void
}

/**
 * Ready-made dropdown menu item for opening the Sentry user feedback form.
 * Any dropdown can call this hook once and spread the result into its
 * `items` array -- no refs or per-dropdown wiring required.
 */
export const useReportIssueMenuItem = (): MenuItemWithHandler => {
  const { openReportIssueForm } = useReportIssueFeedback()

  return {
    key: "report-issue",
    icon: <BugOutlined />,
    label: "Report an Issue",
    onClick: openReportIssueForm,
  }
}
